<template>
  <div>
    <h3 class="booth-subheader" v-show="!meetingsEnded">Meeting Schedule</h3>

    <div
      v-for="(meeting, index) in meetings"
      :key="index"
      :class="!meeting.is_ended ? 'meetings-wrapper' : ''"
    >
      <div v-if="!meeting.is_ended">
        <i class="fa-regular fa-calendar-clock text danger"></i>

        <!-- Date -->
        <span
          class="text-uppercase"
          v-html="meeting.period_formatted"
        ></span>
      </div>

      <!-- Meet Now Button -->
      <c-button
        v-show="meeting.in_process"
        v-if="!meeting.is_ended"
        :href="`${meeting.forward_meeting_url}?attendeeId=${attendeeId}`"
        target="_blank"
        fill
        uppercase
        theme="primary"
        icon="fa-calendar-clock"
      >Meet Now</c-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import "moment-timezone";

export default {
  mounted() {
    let countMeetings
    let meetingsEnded = 0

    this.meetings = JSON.parse(JSON.stringify(this.additionalDates))

    countMeetings = this.meetings.length

    this.meetings.forEach(elem => {
      let startAt
      let endAt

      if (moment(this.convertTZ(new Date(), elem.timezone)).isAfter(moment(elem.end_at))) {
        elem.is_ended = true
        meetingsEnded++
      } else {
        elem.is_ended = false
      }

      if (moment(elem.start_at).isSame(moment(this.convertTZ(new Date(), elem.timezone)), 'day')) {
        startAt = moment(elem.start_at).format('HH:mm')
        endAt = moment(elem.end_at).format('HH:mm')

        setInterval(() => {
          if (moment(this.convertTZ(new Date(), elem.timezone), 'HH:mm').isBetween(moment(startAt, 'HH:mm'), moment(endAt, 'HH:mm'))) {
            elem.in_process = true
          } else {
            elem.in_process = false
          }

          if (moment(this.convertTZ(new Date(), elem.timezone)).isAfter(moment(elem.end_at))) {
            elem.is_ended = true
          } else {
            elem.is_ended = false
          }
        }, 10000)
      }
    })

    if (countMeetings == meetingsEnded) {
      this.meetingsEnded = true
    }
  },
  data() {
    return {
      attendeeId: this.$route.params.attendeeId,
      sponsorId: this.$route.params.sponsorId,

      meetings: [],
      meetingsEnded: false
    }
  },
  computed: {
    ...mapGetters('boothStore', [
      'additionalDates'
    ]),
  },
  methods: {
    convertTZ(date, tzString) {
      return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}));
    }
  }
}
</script>

<style lang="scss" scoped>
.meetings-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.booth-subheader {
  margin-bottom: 15px;
}
</style>
